import React from "react";
import TablePagesTitle from "../../components/table-pages-title/TablePagesTitle";
import AccSoftwareTable from "../../components/table/all-tables/accountingsoftwaretable/AccSoftwareTable";
import AccessPageAction from "../accessmanagment/page-action/AccessPageAction";
import LoginAsUser from "../../components/loginasuser/LoginAsUser";
import { accSoftwarePage, myAccount } from "../../locales/en";
import ComponentViewFallback from "../../components/error-boundary/fallback/ComponentViewFallback";
import ErrorBoundary from "../../components/error-boundary";

const AccountingSoftware = () => {
  return (
    <>
      <LoginAsUser />
      <TablePagesTitle mainTitle={myAccount?.tabNames.accSoftware} />
      <AccessPageAction
        subheading={accSoftwarePage?.subheading}
        alluser="/admin/accounting-softwares"
        allUserTitle={accSoftwarePage?.subheading}
        createuser="/admin/accounting-softwares/create"
        createUserTitle={accSoftwarePage?.createBtn}
      />
      <ErrorBoundary fallback={<ComponentViewFallback />}>
        <div className="row mb-3 mx-0">
          <div className="col-12">
            <AccSoftwareTable />
          </div>
        </div>
      </ErrorBoundary>
    </>
  );
};

export default AccountingSoftware;
